//Review history worked on fixing the page currently working as intended major corrections /-DeveloperVs
//TL;DR: Native <select> is fragile when options change during interaction. Custom components give you full control over the open/close lifecycle and avoid React's reconciliation quirks with native form elements.
// import React, { useState, useEffect } from "react";
// import Colors from "../../Constants/Colors";
// import eyeLock from "../../Assets/Images/CommanImages/eyeLock.png";
// import redDoc from "../../Assets/Images/CommanImages/redDoc.png";
// import yellowDoc from "../../Assets/Images/CommanImages/yellowDoc.png";

// const BonusQuestionTable = ({ rows: initialRows = [], onChange }) => {
//   const [rows, setRows] = useState(initialRows);

//   useEffect(() => {
//     setRows(initialRows);
//   }, [initialRows]);

//   useEffect(() => {
//     if (onChange) onChange(rows);
//   }, [rows, onChange]);

//   const handleDelete = () => {
//     const updatedRows = rows.filter((r) => !r.selected);
//     setRows(updatedRows);
//   };

//   const handleAddRow = () => {
//     setRows([
//       ...rows,
//       {
//         id: Date.now(),
//         questionNo: "",
//         questionText: "",
//         bonusMarks: 0,
//         reason: "",
//         selected: false,
//       },
//     ]);
//   };

//   const toggleSelect = (id) => {
//     setRows(
//       rows.map((r) => (r.id === id ? { ...r, selected: !r.selected } : r))
//     );
//   };

//   const toggleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setRows(rows.map((r) => ({ ...r, selected: checked })));
//   };

//   const handleInputChange = (idx, field, value) => {
//     const updatedRows = [...rows];
//     updatedRows[idx][field] = value;
//     setRows(updatedRows);
//   };

//   return (
//     <div
//       style={{
//         border: "none",
//         overflowX: "auto",
//         width: "99%",
//         marginBottom: "20px",
//       }}
//     >
//       {/* Top bar */}
//       <div
//         style={{
//           background: Colors.color7,
//           padding: "8px 16px",
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           borderBottom: `1px solid ${Colors.color3}`,
//           borderTop: `1px solid ${Colors.color3}`,
//         }}
//       >
//         <button
//           onClick={handleDelete}
//           style={{
//             marginRight: 10,
//             border: "none",
//             background: "transparent",
//             cursor: "pointer",
//           }}
//         >
//           <img src={redDoc} alt="" style={{ height: "18px", width: "18px" }} />{" "}
//           Delete
//         </button>
//         <button
//           onClick={handleAddRow}
//           style={{
//             border: "none",
//             background: "transparent",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             src={yellowDoc}
//             alt=""
//             style={{ height: "18px", width: "18px" }}
//           />{" "}
//           Add Row
//         </button>
//       </div>

//       {/* Header */}
//       <div
//         style={{
//           display: "flex",

//           fontWeight: "bold",
//           padding: "10px 16px",
//           borderBottom: `1px solid ${Colors.color9}`,
//         }}
//       >
//         <div style={{ width: 30 }}>
//           <input type="checkbox" onChange={toggleSelectAll} />
//         </div>
//         <div style={{ width: 80 }}>Question #</div>
//         <div style={{ flex: 2 }}>Question Text</div>
//         <div style={{ width: 120 }}>Bonus Marks</div>
//         <div style={{ flex: 1 }}>Reason</div>
//       </div>

//       {/* Rows */}
//       {rows.map((row, idx) => (
//         <div
//           key={row.id}
//           style={{
//             color: Colors.color1,
//             display: "flex",
//             alignItems: "center",
//             padding: "10px 16px",
//             borderBottom: `1px solid ${Colors.color9}`,
//             backgroundColor: row.selected
//               ? `${Colors.color8}`
//               : idx % 2 === 1
//               ? Colors.color8
//               : "white",
//           }}
//         >
//           <div style={{ width: 30 }}>
//             <input
//               type="checkbox"
//               checked={row.selected}
//               style={{ color: Colors.color1 }}
//               onChange={() => toggleSelect(row.id)}
//             />
//           </div>
//           <div
//             style={{
//               width: 80,
//               display: "flex",
//               alignItems: "center",
//               color: Colors.color1,
//             }}
//           >
//             <img
//               src={eyeLock}
//               alt=""
//               style={{ height: "24px", width: "24px", marginRight: "10px" }}
//             />
//             <select
//               value={row.questionNo}
//               onChange={(e) =>
//                 handleInputChange(idx, "questionNo", e.target.value)
//               }
//               style={{ width: 50 }}
//             >
//               <option value={row.questionNo}>{row.questionNo}</option>
//             </select>
//           </div>
//           <div style={{ flex: 2 }}>{row.questionText}</div>
//           <div style={{ width: 120 }}>
//             <input
//               type="number"
//               value={row.bonusMarks}
//               onChange={(e) =>
//                 handleInputChange(idx, "bonusMarks", e.target.value)
//               }
//               style={{
//                 width: "70%",
//                 padding: "4px",
//                 border: "none",
//                 color: Colors.color1,
//                 backgroundColor: "transparent",
//               }}
//             />
//           </div>
//           <div style={{ flex: 1 }}>
//             <input
//               type="text"
//               value={row.reason}
//               onChange={(e) => handleInputChange(idx, "reason", e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "4px",
//                 border: "none",
//                 color: Colors.color1,
//                 backgroundColor: "transparent",
//               }}
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BonusQuestionTable;

// import React, { useState, useEffect } from "react";
// import Colors from "../../Constants/Colors";
// import eyeLock from "../../Assets/Images/CommanImages/eyeLock.png";
// import redDoc from "../../Assets/Images/CommanImages/redDoc.png";
// import yellowDoc from "../../Assets/Images/CommanImages/yellowDoc.png";
// import "./BonusTable.css";

// const LOCAL_STORAGE_KEY = "QuestionCorrectionDetails";

// const BonusQuestionTable = ({ allQuestions = [], onChange, currentSet }) => {
//   const [rows, setRows] = useState([]);

//   // Load from localStorage when currentSet changes
//   useEffect(() => {
//     if (!currentSet) return;

//     const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
//     const existing = saved[currentSet];

//     if (existing && Array.isArray(existing)) {
//       setRows(existing);
//       onChange?.(existing);
//     } else {
//       const defaultRow = [
//         {
//           id: Date.now(),
//           questionNo: "",
//           questionText: "",
//           bonusMarks: 0,
//           reason: "Reason to give Bonus Marks",
//           attempted: "Only attempted",
//           selected: false,
//         },
//       ];
//       setRows(defaultRow);
//       onChange?.(defaultRow);
//     }
//   }, [currentSet]);

//   // Persist rows to localStorage whenever they change
//   useEffect(() => {
//     if (!currentSet) return;
//     const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
//     saved[currentSet] = rows;
//     localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(saved));
//     onChange?.(rows);
//   }, [rows, currentSet]);

//   const handleDelete = () => {
//     const updatedRows = rows.filter((r) => !r.selected);
//     setRows(updatedRows);
//   };

//   const handleAddRow = () => {
//     setRows([
//       ...rows,
//       {
//         id: Date.now(),
//         questionNo: "",
//         questionText: "",
//         bonusMarks: 0,
//         reason: "Reason to give Bonus Marks",
//         attempted: "Only attempted",
//         selected: false,
//       },
//     ]);
//   };

//   const toggleSelect = (id) => {
//     setRows(
//       rows.map((r) => (r.id === id ? { ...r, selected: !r.selected } : r))
//     );
//   };

//   const toggleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setRows(rows.map((r) => ({ ...r, selected: checked })));
//   };

//   const handleInputChange = (idx, field, value) => {
//     const updatedRows = [...rows];

//     if (field === "questionNo") {
//       const selectedQ = allQuestions.find(
//         (q) => q.ques_number.toString().padStart(2, "0") === value
//       );
//       if (selectedQ) {
//         updatedRows[idx].questionText = selectedQ.ques_text;
//       }
//     }

//     updatedRows[idx][field] = value;
//     setRows(updatedRows);
//   };

//   const getQuestionOptions = (usedNumbers) => {
//     return allQuestions
//       .filter(
//         (q) => !usedNumbers.includes(q.ques_number.toString().padStart(2, "0"))
//       )
//       .map((q) => q.ques_number.toString().padStart(2, "0"));
//   };

//   const usedQuestionNumbers = rows.map((r) => r.questionNo);
//   const availableOptions = getQuestionOptions(usedQuestionNumbers);

//   const attemptedOptions = [
//     { id: "Only attempted", label: "Only attempted" },
//     { id: "All", label: "All" },
//   ];

//   return (
//     <div
//       style={{
//         border: "none",
//         overflowX: "auto",
//         width: "99%",
//         marginBottom: "20px",
//       }}
//     >
//       <div
//         style={{
//           background: Colors.color7,
//           padding: "8px 16px",
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           borderBottom: `1px solid ${Colors.color3}`,
//           borderTop: `1px solid ${Colors.color3}`,
//         }}
//       >
//         <button
//           onClick={handleDelete}
//           style={{
//             marginRight: 10,
//             border: "none",
//             background: "transparent",
//             cursor: "pointer",
//           }}
//         >
//           <img src={redDoc} alt="" style={{ height: "18px", width: "18px" }} />{" "}
//           Delete
//         </button>
//         <button
//           onClick={handleAddRow}
//           style={{
//             border: "none",
//             background: "transparent",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             src={yellowDoc}
//             alt=""
//             style={{ height: "18px", width: "18px" }}
//           />{" "}
//           Add Row
//         </button>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           fontWeight: "bold",
//           padding: "10px 16px",
//           borderBottom: `1px solid ${Colors.color9}`,
//         }}
//       >
//         <div style={{ width: 30 }}>
//           <input type="checkbox" onChange={toggleSelectAll} />
//         </div>
//         <div style={{ width: 80 }}>Question #</div>
//         <div style={{ flex: 2 }}>Question Text</div>
//         <div style={{ width: 130 }}>Bonus Marks</div>
//         <div style={{ width: 170, paddingLeft: 12 }}>Scope</div>
//         <div style={{ flex: 1, paddingLeft: 12 }}>Reason</div>
//       </div>

//       {rows.map((row, idx) => (
//         <div
//           key={row.id}
//           style={{
//             color: Colors.color1,
//             display: "flex",
//             alignItems: "center",
//             padding: "10px 16px",
//             borderBottom: `1px solid ${Colors.color9}`,
//             backgroundColor: row.selected
//               ? Colors.color8
//               : idx % 2 === 1
//               ? Colors.color8
//               : "white",
//           }}
//         >
//           <div style={{ width: 30 }}>
//             <input
//               type="checkbox"
//               checked={row.selected}
//               onChange={() => toggleSelect(row.id)}
//             />
//           </div>
//           {/* <div style={{ width: 80, display: "flex", alignItems: "center" }}>
//             <img
//               src={eyeLock}
//               alt=""
//               style={{ height: "24px", width: "24px", marginRight: "10px" }}
//             />
//             <select
//               value={row.questionNo}
//               onChange={(e) =>
//                 handleInputChange(idx, "questionNo", e.target.value)
//               }
//               style={{ width: 50, marginRight: 10 }}
//             >
//               <option value="">-</option>
//               {availableOptions.concat(row.questionNo).map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//           </div> */}
//           <div style={{ width: 80, display: "flex", alignItems: "center" }}>
//             {allQuestions.find(
//               (q) =>
//                 q.ques_number.toString().padStart(2, "0") === row.questionNo
//             )?.special_status && (
//               <img
//                 src={eyeLock}
//                 alt=""
//                 style={{ height: "24px", width: "24px", marginRight: "10px" }}
//               />
//             )}
//             <select
//               value={row.questionNo}
//               onChange={(e) =>
//                 handleInputChange(idx, "questionNo", e.target.value)
//               }
//               style={{ width: 50 }}
//             >
//               <option value="">-</option>
//               {availableOptions.concat(row.questionNo).map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div
//             style={{ flex: 2 }}
//             dangerouslySetInnerHTML={{ __html: row.questionText }}
//           />

//           <div style={{ width: 130 }}>
//             <input
//               type="number"
//               value={row.bonusMarks}
//               onChange={(e) =>
//                 handleInputChange(idx, "bonusMarks", e.target.value)
//               }
//               style={{
//                 height: "30px",
//                 width: "90%",
//                 padding: "4px",
//                 border: `1px solid ${Colors.color3}`,
//                 color: Colors.color1,
//               }}
//             />
//           </div>

//           <div style={{ width: 170, paddingLeft: 12 }}>
//             <select
//               value={row.attempted}
//               onChange={(e) =>
//                 handleInputChange(idx, "attempted", e.target.value)
//               }
//               style={{
//                 width: "100%",
//                 height: "30px",
//                 padding: "4px",
//                 border: `1px solid ${Colors.color3}`,
//                 color: Colors.color1,
//               }}
//             >
//               <option value="">Select Attempted</option>
//               {attemptedOptions.map((opt) => (
//                 <option key={opt.id} value={opt.id}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div style={{ flex: 1, paddingLeft: 12 }}>
//             <input
//               type="text"
//               value={row.reason}
//               placeholder="Reason to give Bonus Marks"
//               onChange={(e) => handleInputChange(idx, "reason", e.target.value)}
//               style={{
//                 width: "100%",
//                 height: "30px",
//                 padding: "4px",
//                 border: `1px solid ${Colors.color3}`,
//                 color: Colors.color1,
//               }}
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BonusQuestionTable;




import React, { useState, useEffect, useRef } from "react";
import Colors from "../../Constants/Colors";
import eyeLock from "../../Assets/Images/CommanImages/eyeLock.png";
import redDoc from "../../Assets/Images/CommanImages/redDoc.png";
import yellowDoc from "../../Assets/Images/CommanImages/yellowDoc.png";
import "./BonusTable.css";
// import DropDown from "../../Pages/CreateBatch/DropdownCB";
import BonusDropDown from "../../Pages/TestPaperBonusCorrection/DropdownForBonusTable";
const LOCAL_STORAGE_KEY = "QuestionCorrectionDetails";

const BonusQuestionTable = ({ allQuestions = [], onChange, currentSet }) => {
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
  const searchDropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // Load from localStorage when currentSet changes
  useEffect(() => {
    if (!currentSet) return;

    const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
    const existing = saved[currentSet];

    if (existing && Array.isArray(existing)) {
      setRows(existing);
      onChange?.(existing);
    } else {
      const defaultRow = [
        {
          id: Date.now(),
          questionNo: "",
          questionId: "",
          questionText: "",
          bonusMarks: 0,
          reason: "Reason to give Bonus Marks",
          attempted: "Only attempted",
          selected: false,
        },
      ];
      setRows(defaultRow);
      onChange?.(defaultRow);
    }
  }, [currentSet]);

  // Persist rows to localStorage whenever they change
  useEffect(() => {
    if (!currentSet) return;
    const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
    saved[currentSet] = rows;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(saved));
    onChange?.(rows);
  }, [rows, currentSet]);

  // Close search dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setShowSearchDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Calculate dropdown position when showing
  useEffect(() => {
    if (showSearchDropdown && searchInputRef.current) {
      const rect = searchInputRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [showSearchDropdown]);

  // Update dropdown position on scroll
  useEffect(() => {
    if (!showSearchDropdown) return;

    const handleScroll = () => {
      if (searchInputRef.current) {
        const rect = searchInputRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + window.scrollY + 4,
          left: rect.left + window.scrollX,
          width: rect.width,
        });
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [showSearchDropdown]);

  // Filter questions based on search query
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredQuestions([]);
      setShowSearchDropdown(false);
      return;
    }

    const query = searchQuery.toLowerCase();
    const usedQuestionIds = rows.map((r) => r.questionId);

    const filtered = allQuestions.filter((q) => {
      const quesIdMatch = q.id?.toString().toLowerCase().includes(query);
      const quesTextMatch = q.ques_text?.toLowerCase().includes(query);
      const quesNumberMatch = q.ques_number?.toString().includes(query);
      const isNotUsed = !usedQuestionIds.includes(q.id?.toString());

      return (quesIdMatch || quesTextMatch || quesNumberMatch) && isNotUsed;
    });

    setFilteredQuestions(filtered);
    setShowSearchDropdown(filtered.length > 0);
  }, [searchQuery, allQuestions, rows]);

  const handleDelete = () => {
    const updatedRows = rows.filter((r) => !r.selected);
    setRows(updatedRows);
  };

  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter((r) => r.id !== id);
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: Date.now(),
        questionNo: "",
        questionId: "",
        questionText: "",
        bonusMarks: 0,
        reason: "Reason to give Bonus Marks",
        attempted: "Only attempted",
        selected: false,
      },
    ]);
    // Add these lines to prevent search dropdown from appearing
    setSearchQuery("");
    setShowSearchDropdown(false);
  };


  const handleAddFromSearch = (question) => {
    const newRow = {
      id: Date.now(),
      questionNo: question.ques_number.toString().padStart(2, "0"),
      questionId: question.id.toString(),
      questionText: question.ques_text,
      bonusMarks: 0,
      reason: "Reason to give Bonus Marks",
      attempted: "Only attempted",
      selected: false,
    };
    setRows([...rows, newRow]);
    setSearchQuery("");
    setShowSearchDropdown(false);
  };

  const toggleSelect = (id) => {
    setRows(
      rows.map((r) => (r.id === id ? { ...r, selected: !r.selected } : r))
    );
  };

  const toggleSelectAll = (e) => {
    const checked = e.target.checked;
    setRows(rows.map((r) => ({ ...r, selected: checked })));
  };

  const handleInputChange = (idx, field, value) => {
    const updatedRows = [...rows];

    if (field === "questionNo") {
      const selectedQ = allQuestions.find(
        (q) => q.ques_number.toString().padStart(2, "0") === value
      );
      if (selectedQ) {
        updatedRows[idx].questionText = selectedQ.ques_text;
        updatedRows[idx].questionId = selectedQ.id.toString(); // This line should already be there
      } else {
        // Add this else block to clear data when no question is selected
        updatedRows[idx].questionText = "";
        updatedRows[idx].questionId = "";
      }
    }

    updatedRows[idx][field] = value;
    setRows(updatedRows);
  };


  const getQuestionOptions = (usedNumbers) => {
    return allQuestions
      .filter(
        (q) => !usedNumbers.includes(q.ques_number.toString().padStart(2, "0"))
      )
      .map((q) => q.ques_number.toString().padStart(2, "0"));
  };

  const usedQuestionNumbers = rows.map((r) => r.questionNo);
  const availableOptions = getQuestionOptions(usedQuestionNumbers);

  // Get options for a specific row, excluding other rows' selected numbers
  const getOptionsForRow = (currentRowQuestionNo) => {
    const usedNumbersExceptCurrent = rows
      .filter((r) => r.questionNo !== currentRowQuestionNo)
      .map((r) => r.questionNo);

    return allQuestions
      .filter(
        (q) =>
          !usedNumbersExceptCurrent.includes(
            q.ques_number.toString().padStart(2, "0")
          )
      )
      .map((q) => ({
        id: q.ques_number.toString().padStart(2, "0"),
        label: q.ques_number.toString().padStart(2, "0"),
      }));
  };


  const optionsForRow = getOptionsForRow(rows.questionNo);

  const attemptedOptions = [
    { id: "Only attempted", label: "Only attempted" },
    { id: "All", label: "All" },
  ];

  // Strip HTML for search display
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const handleDeleteAll = () => {
    if (rows.length === 0) {
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete all ${rows.length} row(s)? This action cannot be undone.`
    );

    if (confirmDelete) {
      setRows([]);
    }
  };

  return (
    <div
      style={{
        border: "none",
        overflowX: "auto",
        width: "99%",
        marginBottom: "20px",
      }}
    >
      {/* Combined Search Input and Action Buttons Section */}
      <div
        style={{
          background: Colors.color7,
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${Colors.color3}`,
          borderTop: `1px solid ${Colors.color3}`,
        }}
      >
        {/* Search Input on the Left */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, maxWidth: "480px" }}>
          <label style={{ fontWeight: "bold", minWidth: "100px" }}>
            Search Question:
          </label>
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search by Question ID, Number, or Text..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              flex: 1,
              height: "32px",
              padding: "4px 8px",
              border: `1px solid ${Colors.color3}`,
              // borderRadius: "4px",
              color: Colors.color1,

            }}
          />
        </div>

        {/* Action Buttons on the Right */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            onClick={handleDeleteAll}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img src={redDoc} alt="" style={{ height: "18px", width: "18px" }} />
            Remove All
          </button>
          <button
            onClick={handleAddRow}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img
              src={yellowDoc}
              alt=""
              style={{ height: "18px", width: "18px" }}
            />
            Add Row
          </button>
        </div>
      </div>

      {/* Search Results Dropdown - Now as a Fixed Popup */}
      {showSearchDropdown && (
        <div
          ref={searchDropdownRef}
          style={{
            position: "fixed",
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            width: `${dropdownPosition.width}px`,
            maxHeight: "250px",
            overflowY: "auto",
            background: "white",
            border: `1px solid ${Colors.color3}`,
            borderRadius: "4px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
            zIndex: 999,
          }}
        >
          {filteredQuestions.map((q) => (
            <div
              key={q.id}
              onClick={() => handleAddFromSearch(q)}
              style={{
                padding: "10px",
                borderBottom: `1px solid ${Colors.color9}`,
                cursor: "pointer",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = Colors.color8)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "white")
              }
            >
              <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                Question ID: {q.id} | Question #:{" "}
                {q.ques_number.toString().padStart(2, "0")}
                {/* {q.special_status && (
                  <img
                    src={eyeLock}
                    alt="locked"
                    style={{
                      height: "16px",
                      width: "16px",
                      marginLeft: "8px",
                      verticalAlign: "middle",
                    }}
                  />
                )} */}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: Colors.color1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {stripHtml(q.ques_text)}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Table Header */}
      <div
        style={{
          display: "flex",
          fontWeight: "bold",
          padding: "10px 16px",
          borderBottom: `1px solid ${Colors.color9}`,
        }}
      >
        <div style={{ width: 65 }}>Ques ID</div>
        {/* <div style={{ width: 30, marginTop: 2 }}>
          <input type="checkbox" onChange={toggleSelectAll} />
        </div> */}
        <div style={{ width: 30 }}></div>
        <div style={{ width: 80 }}>Question #</div>
        <div style={{ flex: 2 }}>Question Text</div>
        <div style={{ width: 130 }}>Bonus Marks</div>
        <div style={{ width: 170, paddingLeft: 12 }}>Scope</div>
        <div style={{ flex: 1, paddingLeft: 12 }}>Reason</div>
      </div>

      {/* Table Rows */}
      {rows.map((row, idx) => (
        <div
          key={row.id}
          style={{
            color: Colors.color1,
            display: "flex",
            alignItems: "center",
            padding: "10px 16px",
            borderBottom: `1px solid ${Colors.color9}`,
            backgroundColor: row.selected
              ? Colors.color8
              : idx % 2 === 1
                ? Colors.color8
                : "white",
          }}
        >
          {/* Question ID Column */}
          <div style={{ width: 65, fontWeight: "500" }}>{row.questionId}</div>

          {/* Checkbox */}
          {/* <div style={{ width: 30, marginTop: 2 }}>
            <input
              type="checkbox"
              checked={row.selected}
              onChange={() => toggleSelect(row.id)}
            />
          </div> */}

          {/* Red Cross Delete Button */}
          <div style={{ width: 30 }}>
            <button
              onClick={() => handleDeleteRow(row.id)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: Colors.color15,
                fontSize: "18px",
                fontWeight: "bold",
                padding: "0",
              }}
              title="Delete this row"
            >
              ×
            </button>
          </div>

          {/* Question Number with Lock Icon */}
          <div style={{ width: 80, display: "flex", alignItems: "center" }}>
            {/* {allQuestions.find(
              (q) =>
                q.ques_number.toString().padStart(2, "0") === row.questionNo
            )?.special_status && (
                <img
                  src={eyeLock}
                  alt=""
                  style={{ height: "24px", width: "24px", marginRight: "4px" }}
                />
              )} */}
            {/* <select
              value={row.questionNo}
              onChange={(e) =>
                handleInputChange(idx, "questionNo", e.target.value)
              }
              style={{ width: 50 }}
            >
              <option value="">-</option>
              {availableOptions.concat(row.questionNo).map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select> */}
            <div style={{ width: 80, display: "flex", alignItems: "center" }}>
              {/* <DropDown
                width={"90%"}
                label={""}
                selected={row.questionNo}
                setSelected={(value) => handleInputChange(idx, "questionNo", value)}
                options={getOptionsForRow(row.questionNo)}
                isRequired={false}
                style={{}}
                className="question-no-dropdown"
              /> */}
              <div style={{ width: 80, display: "flex", alignItems: "center" }}>
                <BonusDropDown
                  width={"90%"}
                  label=""
                  selected={row.questionNo}
                  setSelected={(value) => handleInputChange(idx, "questionNo", value)}
                  options={getOptionsForRow(row.questionNo)}
                  isRequired={false}
                  style={{}}
                  className="question-no-dropdown"
                />
              </div>


            </div>


          </div>

          {/* Question Text */}
          <div
            style={{ flex: 2, padding: "0 5px" }}
            dangerouslySetInnerHTML={{ __html: row.questionText }}
          />

          {/* Bonus Marks */}
          <div style={{ width: 130 }}>
            <input
              type="number"
              value={row.bonusMarks}
              onChange={(e) =>
                handleInputChange(idx, "bonusMarks", e.target.value)
              }
              style={{
                height: "30px",
                width: "90%",
                padding: "4px",
                border: `1px solid ${Colors.color3}`,
                color: Colors.color1,
              }}
            />
          </div>

          {/* Scope */}
          <div style={{ width: 170, paddingLeft: 12 }}>
            <BonusDropDown
              width={"100%"}
              label=""
              selected={row.attempted}
              setSelected={(value) => handleInputChange(idx, "attempted", value)}
              options={attemptedOptions}
              isRequired={false}
              style={{}}
              className="scope-dropdown"
            />
          </div>



          {/* Reason */}
          <div style={{ flex: 1, paddingLeft: 12 }}>
            <input
              type="text"
              value={row.reason}
              placeholder="Reason to give Bonus Marks"
              onChange={(e) => handleInputChange(idx, "reason", e.target.value)}
              style={{
                width: "100%",
                height: "30px",
                padding: "4px",
                border: `1px solid ${Colors.color3}`,
                color: Colors.color1,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BonusQuestionTable;
